interface CalculationTabHeaderProps {
  calculationCount: number;
}

const CalculationTabHeader = ({
  calculationCount,
}: CalculationTabHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <h1 className="txt-extra-large-bold flex items-center gap-2 text-text-secondary">
          Tax Calculations
        </h1>
        <div className="border border-utility-gray-200 bg-utility-gray-50 flex items-center justify-center rounded-sm txt-extra-small-bold text-utility-gray-700 size-6">
          {calculationCount}
        </div>
      </div>
    </div>
  );
};

export default CalculationTabHeader;
